/** Shared compact layout tokens for packing list on tablet. */
export const PACKING_TABLET_ROW_HEIGHT = 36;

export const packingTabletFiltersSx = {
  "& > .MuiBox-root": {
    gap: 0.5,
    pt: 0,
    pb: 0,
  },
  "& .MuiAccordionSummary-root": {
    minHeight: 40,
    py: 0,
    px: 0.5,
  },
  "& .MuiAccordionSummary-content": {
    my: 0.5,
  },
  "& .MuiAccordionDetails-root": {
    pt: 0.5,
    pb: 0.5,
    px: 0.5,
  },
  "& .MuiAccordion-root": {
    boxShadow: "none",
    "&:before": { display: "none" },
  },
};
